import React from "react";
import Globe from "react-globe.gl";

interface WorldMapProps {
  globePoints: GeoPoint[];
}

export type GeoPoint = {
  lat: number;
  lng: number;
  radius: number;
  color: string;
  altitude: number;
};

export default function WorldMap({ globePoints }: WorldMapProps) {
  return (
    <Globe
      pointsData={globePoints}
      hexBinPointWeight="altitude"
      hexAltitude={(d) => d.sumWeight * 6e-8}
      width={300}
      height={300}
      animateIn={true}
      // Optional: Set a background color
      backgroundColor="lightblue"
      // Optional: Set a specific globe image
      globeImageUrl="//unpkg.com/three-globe/example/img/earth-day.jpg"
    />
  );
}
